import { Component } from '@angular/core';

@Component({
  selector: 'mon-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent {}
